export default __webpack_public_path__ + "static/media/QuestionMark.e9c6201e.svg";